import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import draftBarImg from '../../../assets/images/status_bar_draft.svg';
import underReviewBarImg from '../../../assets/images/status_bar_under_review.svg';
import liveBarImg from '../../../assets/images/status_bar_live.svg';
import matchedBarImg from '../../../assets/images/status_bar_matched.svg';
import workStartedBarImg from '../../../assets/images/status_bar_work_started.svg';
import workCompletedBarImg from '../../../assets/images/status_bar_work_completed.svg';
import openMarketplaceLiveBarImg from '../../../assets/images/open_marketplace_status_bar_live.svg';
import openMarketplaceMatchedBarImg from '../../../assets/images/open_marketplace_status_bar_matched.svg';
import openMarketplaceWorkStartedBarImg from '../../../assets/images/open_marketplace_status_bar_work_started.svg';
import openMarketplaceWorkCompletedBarImg from '../../../assets/images/open_marketplace_status_bar_work_completed.svg';
import './ProjectStatusBar.scss';

const renderBarStatus = (status, isOpenMarketplaceOrRehire) => {
  if (status === 'employer_draft') {
    return (
      <h2 className="demibold">Draft</h2>
    );
  } if (status === 'employer_requested_matching') {
    if (isOpenMarketplaceOrRehire) {
      return (
        <h2 className="demibold">Live!</h2>
      );
    }
    return (
      <h2 className="demibold">
        Under Review&nbsp;
        <OverlayTrigger
          placement="right"
          delay={{ show: 100 }}
          overlay={(
            <Tooltip id="project-status-tooltip">
              Clora will help you to shape your project&#39;s needs in a scoping call!
            </Tooltip>
          )}
        >
          <i className="fas fa-info-circle" />
        </OverlayTrigger>
      </h2>
    );
  } if (status === 'clora_matching') {
    return (
      <h2 className="demibold">
        Sourcing&nbsp;
        <OverlayTrigger
          placement="right"
          delay={{ show: 100 }}
          overlay={(
            <Tooltip id="project-status-tooltip">
              Your project is now public in our marketplace and our life-science
              experts are vetting candidates for you.
            </Tooltip>
          )}
        >
          <i className="fas fa-info-circle" />
        </OverlayTrigger>
      </h2>
    );
  } if (status === 'closed') {
    return (
      <h2 className="demibold">Closed</h2>
    );
  } if (status === 'clora_matched' || status === 'executed_agreement') {
    return (
      <h2 className="demibold">Matched</h2>
    );
  } if (status === 'work_started') {
    return (
      <h2 className="demibold">Work Started</h2>
    );
  } if (status === 'work_completed') {
    return (
      <h2 className="demibold">Work Completed</h2>
    );
  } if (status === 'on_hold') {
    return (
      <h2 className="demibold">On Hold</h2>
    );
  }
  return null;
};

const renderBarImage = (status, isOpenMarketplaceOrRehire) => {
  if (status === 'employer_draft') {
    return (
      <img src={draftBarImg} alt="Draft" />
    );
  } if (status === 'employer_requested_matching') {
    if (isOpenMarketplaceOrRehire) {
      return (
        <img src={openMarketplaceLiveBarImg} alt="Sourcing" />
      );
    }
    return (
      <img src={underReviewBarImg} alt="Under Review" />
    );
  } if (status === 'clora_matching') {
    return (
      <img src={liveBarImg} alt="Sourcing" />
    );
  } if (status === 'closed') {
    return null;
  } if (status === 'clora_matched' || status === 'executed_agreement') {
    if (isOpenMarketplaceOrRehire) {
      return (
        <img src={openMarketplaceMatchedBarImg} alt="Matched" />
      );
    }
    return (
      <img src={matchedBarImg} alt="Matched" />
    );
  } if (status === 'work_started') {
    if (isOpenMarketplaceOrRehire) {
      return (
        <img src={openMarketplaceWorkStartedBarImg} alt="Work Started" />
      );
    }
    return (
      <img src={workStartedBarImg} alt="Work Started" />
    );
  } if (status === 'work_completed') {
    if (isOpenMarketplaceOrRehire) {
      return (
        <img src={openMarketplaceWorkCompletedBarImg} alt="Work Completed" />
      );
    }
    return (
      <img src={workCompletedBarImg} alt="Work Completed" />
    );
  } if (status === 'on_hold') {
    return null;
  }
  return null;
};

function ProjectStatusBar({ projectStatus, isOpenMarketplaceOrRehire }) {
  return (
    <div className="inline-headers style-guide">
      <h2 className="medium-weight muted-gray-text">
        Project Status:&nbsp;
      </h2>
      {renderBarStatus(projectStatus, isOpenMarketplaceOrRehire)}
      <div className="status-bar-image-container mt-3">
        {renderBarImage(projectStatus, isOpenMarketplaceOrRehire)}
      </div>
    </div>
  );
}

ProjectStatusBar.propTypes = {
  projectStatus: PropTypes.string.isRequired,
  isOpenMarketplaceOrRehire: PropTypes.bool,
};

ProjectStatusBar.defaultProps = {
  isOpenMarketplaceOrRehire: false,
};

export default ProjectStatusBar;
